__turbopack_context__.v({
  "newsletter-send": "C_0COG_newsletter-send",
  "newsletter-send__button": "C_0COG_newsletter-send__button",
  "newsletter-send__form": "C_0COG_newsletter-send__form",
  "newsletter-send__form-fields": "C_0COG_newsletter-send__form-fields",
  "newsletter-send__popup": "C_0COG_newsletter-send__popup",
  "newsletter-send__popup-buttons": "C_0COG_newsletter-send__popup-buttons",
});
